import { render, staticRenderFns } from "./SuperAdminNavigation.vue?vue&type=template&id=9624f8fa&scoped=true"
import script from "./SuperAdminNavigation.vue?vue&type=script&lang=js"
export * from "./SuperAdminNavigation.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminNavigation.vue?vue&type=style&index=0&id=9624f8fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9624f8fa",
  null
  
)

export default component.exports